const n = "_innerWrapper_z81t4_1", r = "_contentBlockWrapper_z81t4_6", e = "_innerContentWrapper_z81t4_9", t = "_accordionItemBody_z81t4_16", o = {
  innerWrapper: n,
  contentBlockWrapper: r,
  innerContentWrapper: e,
  accordionItemBody: t
};
export {
  t as accordionItemBody,
  r as contentBlockWrapper,
  o as default,
  e as innerContentWrapper,
  n as innerWrapper
};
